import React from 'react';

const LetterAvatar = ({ name, className = "" }) => {
  const firstLetter = name ? name.charAt(0).toUpperCase() : "?";
  return (
    <div className={`letter-avatar ${className}`}>
      {firstLetter}
    </div>
  );
};

export default LetterAvatar;
